---
title: Configuración de correo electrónico y buzón
parent: Documentación
parentHref: /docs
---

# Configuración de su buzón de correo electrónico

Su plan de TOBY incluye una dirección de correo electrónico profesional que coincide con su dominio (por ejemplo, info@su-dominio.de) con un **buzón de 15 GB (Maxi-Postfach)**, más direcciones de reenvío de correo electrónico ilimitadas. ¿Necesita más buzones o almacenamiento adicional? Puede agregar otro buzón de 15 GB en cualquier momento — consulte la [lista de precios](/es/pricing).

## 1. Cree su buzón en TOBY

1. Abra **Ajustes → Correo electrónico** en TOBY.
2. Elija la dirección que desee (como info@, hello@ o contact@) y cree el buzón.
3. **Copie su contraseña:** TOBY muestra la contraseña generada para su buzón una sola vez justo después de la creación. Cópiela o guárdela antes de cerrar la ventana. (Si alguna vez la pierde, puede generar una nueva contraseña con un clic en **Ajustes → Correo electrónico** — sus correos electrónicos existentes permanecen seguros.)

## 2. Leer y enviar correos electrónicos en su navegador (Webmail)

Puede abrir su bandeja de entrada desde cualquier navegador de computadora o teléfono sin instalar una aplicación:

- **Dirección de Webmail:** [mail.tobysite.com/SOGo](https://mail.tobysite.com/SOGo)
- **Nombre de usuario:** su dirección de correo electrónico completa (por ejemplo, info@su-dominio.de)
- **Contraseña:** la contraseña del buzón desde **Ajustes → Correo electrónico**

## 3. Conecte su teléfono o computadora (IMAP y SMTP)

Para leer y enviar correos electrónicos en **Apple Mail (iPhone, iPad, Mac)**, **Gmail / Android Mail**, **Outlook** o **Thunderbird**, agregue una nueva cuenta **IMAP** en su aplicación de correo e introduzca estos ajustes de servidor:

| Ajuste | Valor |
| --- | --- |
| **Tipo de cuenta** | IMAP |
| **Dirección de correo / Nombre de usuario** | Su dirección de correo electrónico completa (por ejemplo, info@su-dominio.de) |
| **Contraseña** | Su contraseña del buzón desde Ajustes → Correo electrónico |
| **Servidor de correo entrante (IMAP)** | mail.tobysite.com |
| **Puerto entrante** | 993 (SSL/TLS) |
| **Servidor de correo saliente (SMTP)** | mail.tobysite.com |
| **Puerto saliente** | 465 (SSL/TLS) o 587 (STARTTLS) |

> **Importante:** Asegúrese de introducir su **dirección de correo electrónico completa** (incluyendo @su-dominio.de) como nombre de usuario para **ambos** servidores, el entrante (IMAP) y el saliente (SMTP).

### Paso a paso en iPhone e iPad (iOS Mail)

1. Abra la aplicación **Ajustes** del iPhone → **Apps** → **Mail** → **Cuentas de Mail** → **Añadir cuenta** → **Otra** → **Añadir cuenta de correo**.
2. Introduzca su nombre, su dirección de correo electrónico completa, su contraseña del buzón y una breve descripción. Pulse **Siguiente**.
3. Mantenga seleccionado **IMAP** en la parte superior.
4. En **Servidor de correo entrante** y **Servidor de correo saliente**, introduzca mail.tobysite.com como Nombre del host, su dirección de correo electrónico completa como Nombre de usuario y su contraseña del buzón.
5. Pulse **Siguiente** y luego **Guardar**.

### Paso a paso en Android (aplicación Gmail)

1. Abra la aplicación **Gmail**, pulse su foto de perfil en la parte superior derecha → **Añadir otra cuenta** → **Otra**.
2. Introduzca su dirección de correo electrónico completa y pulse **Configuración manual** → **Personal (IMAP)**, luego introduzca su contraseña.
3. Para el **Servidor entrante**, establezca el servidor en mail.tobysite.com, puerto 993 y tipo de seguridad SSL/TLS.
4. Para el **Servidor SMTP saliente**, establezca el servidor en mail.tobysite.com, puerto 465 (SSL/TLS), y asegúrese de que **Requiere inicio de sesión** esté habilitado con su dirección de correo electrónico completa.
5. Pulse **Siguiente** para finalizar.

Siguiente: [Boletín y anuncios](/es/docs/newsletter).
